import {
  SaaSBackofficeClient,
  AllGetEndpoints,
  AllPostEndpoints,
  AllPatchEndpoints,
  AllDeleteEndpoints,
} from '@fc/saas-backoffice-client'

export const clientSideAxios = new SaaSBackofficeClient<
  AllGetEndpoints,
  AllPostEndpoints,
  AllPatchEndpoints,
  AllDeleteEndpoints
>({
  baseURL: '/api',
})
